import InfoIcon from "../../../utils/InfoIcon"

const InfoBox = () => {
    return (
        <div className='w-full rounded-[15px] border border-solid border-holifya-grey-shadow p-[10px] space-y-[10px] font-normal text-[14px]'>
            <div className='flex items-center'><div className='font-bold mr-[10px]'>Questa chat è asincrona</div><InfoIcon /></div>
            <div>La tua Medical Equipe ti risponderà nel più breve tempo possibile, impegnandosi sempre a darti una risposta entro le 48 ore dall'invio del tuo messaggio.</div>
        </div>
    )
}

export default InfoBox
